import React, { useEffect, useState } from 'react'
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CTooltip
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { useKeycloak } from '@react-keycloak/web';
import { useAuth } from '../context/auth';
// import { REACT_APP_API_BACKEND } from '../data/data';
import api from 'src/services/api';

const TheHeaderDropdownClient = () => {
  const { keycloak } = useKeycloak();
  const { userAuth, setUserAuth } = useAuth();
  const [clientList, setClientList] = useState([]);

  useEffect(() => {
    api.post("/Usuario/clients", null, {
      params: {
        UserID: userAuth.userID
      }
    })
      .then(res => {
        if (res.data.length > 1) {
          const sortedClients = [...res.data].sort((a, b) =>
            a.name.localeCompare(b.name)
          );

          const currentClientName = sortedClients
            .filter(e => e.clientID == userAuth.clientID)[0].name;

          setClientList(sortedClients);

          setUserAuth({
            nome: userAuth.nome,
            sobrenome: userAuth.sobrenome,
            email: userAuth.email,
            perfilID: null,
            userID: userAuth.userID,
            refreshToken: userAuth.refreshToken,
            token: userAuth.token,
            clientID: userAuth.clientID,
            clientName: currentClientName,
            reloadMenu: true,
            accessToken: {
              headers: {
                Authorization: 'Bearer ' + keycloak.token
              }
            }
          })
        }
      })
      .catch(err => {
        console.log("Erro obter clients do servidor" + err);
      });
  }, []);

  function handleCurrentClient(currentClientID, currentClientName) {

    setUserAuth({
      nome: userAuth.nome,
      sobrenome: userAuth.sobrenome,
      email: userAuth.email,
      perfilID: null,
      userID: userAuth.userID,
      refreshToken: userAuth.refreshToken,
      token: userAuth.token,
      clientID: currentClientID,
      clientName: currentClientName,
      reloadMenu: true,
      accessToken: {
        headers: {
          Authorization: 'Bearer ' + keycloak.token
        }
      }
    })

    window.location.href = "#/"

  }



  return (
    <>
      {clientList.length > 1 &&

        <CDropdown
          inNav
          className="c-header-nav-items mx-2"
          direction="down"
        >
          <CDropdownToggle className="c-header-nav-link" caret={false}>
            {userAuth?.clientName}
          </CDropdownToggle>
          <CDropdownMenu
            className="pt-0"
            placement="bottom-end"
            style={{
              maxHeight: '480px',
              overflowY: 'auto',
              overflowX: 'hidden'
            }}
          >
            <CDropdownItem
              header
              tag="div"
              color="light"
              className="text-center"
            >
              <strong>Clientes</strong>
            </CDropdownItem>
            {clientList?.map(item => {
              const tooltip =
                item.hasOnlineMenu && item.hasOfflineMenu
                  ? "Ativos Online e Offline"
                  : item.hasOnlineMenu
                    ? "Ativos Online"
                    : "Ativos Offline";

              return (
                <CDropdownItem
                  key={item.clientID}
                  onClick={() => handleCurrentClient(item.clientID, item.name)}
                >
                  {/* <CIcon name="cil-user" className="mfe-2" /> */}
                  {item.name}

                  {(item.hasOnlineMenu || item.hasOfflineMenu) && (
                    <CTooltip content={tooltip}>
                      <span>
                        {item.hasOnlineMenu && (
                          <CIcon
                            name="cil-laptop"
                            style={{ color: "#2EB85C", marginLeft: 8 }}
                          />
                        )}

                        {item.hasOfflineMenu && (
                          <CIcon
                            name="cil-laptop"
                            style={{ color: "#E55353", marginLeft: 4 }}
                          />
                        )}
                      </span>
                    </CTooltip>
                  )}
                </CDropdownItem>
              );
            })}
          </CDropdownMenu>
        </CDropdown>
      }
    </>
  )
}

export default TheHeaderDropdownClient
